/**
 * @file: useIsWeWorkAvailable.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useCurrentUser } from '@euler/app/flows/auth/context';
import * as WeWork from '@euler/lib/integration/wework/WeWork';
import { useEffect, useState } from 'react';

export const useIsWeWorkAvailable = () => {
  const [isAvailable, setIsAvailable] = useState(false);

  const user = useCurrentUser();

  const corpId =
    user?.store?.weworkApiCorpId?.trim() && user.store.weworkApiAgentId?.trim()
      ? user.store.weworkApiCorpId.trim()
      : user?.org.weworkApiCorpId?.trim() ?? undefined;

  const agentId =
    user?.store?.weworkApiAgentId?.trim() && user.store.weworkApiAgentId?.trim()
      ? user.store.weworkApiAgentId.trim()
      : user?.org.weworkApiAgentId?.trim() ?? undefined;

  const isWeWorkSettingsAvailable = Boolean(
    corpId && agentId && WeWork.isAppRegistered,
  );

  useEffect(() => {
    WeWork.isAppInstalled()
      .then(installed => {
        if (installed) {
          setIsAvailable(true);
        }
      })
      .catch(() => null);
  }, []);
  return [isAvailable, isWeWorkSettingsAvailable];
};
